<template>
  <div>
    <b-card no-body>
      <div
        class="d-flex justify-content-md-between align-items-md-center flex-column-reverse flex-md-row card-padding"
      >
        <span class="header__label mt-1 mt-md-0">
          Ticket Reply Template Data
        </span>
        <atom-button
          v-if="hasUpdatePermission"
          buttonId="create-new-ticket-reply-template"
          buttonStyle="border"
          class="d-flex justify-content-end"
          @click="showCreateNewTicketReplyTemplateModal"
        >
          <template>Create New Reply Template</template>
        </atom-button>
      </div>

      <div class="row">
        <div class="col-12">
          <b-table
            sticky-header
            responsive
            :items="items"
            :fields="fields"
            :hover="hasUpdatePermission"
            @row-clicked="selectRow"
          >
            <template #cell(index)="data">
              <div class="header">{{ data.value }}</div>
            </template>
            <template #cell(replyTemplateName)="data">
              <div class="header">{{ data.value }}</div>
            </template>
            <template #cell(replyTemplateMessage)="data">
              <div class="header">{{ data.value }}</div>
            </template>
          </b-table>
        </div>
      </div>
    </b-card>

    <!-- ? Modal Create Reply Template -->
    <!-- start modal create -->
    <molecule-modal-dialog
      modalId="modal-create-new-reply-template"
      buttonTextLeft="Create"
      buttonColorLeft="primary"
      textTitle="New Reply Template"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      :isDisableButtonLeft="isErrorAtNewReplyTemplate"
      @clickButtonLeft="clickConfirmCreateReplyTemplateFromModal"
      @clickButtonRight="clickCancelCreateReplyTemplateFromModal"
      @clickIconClose="clickCancelCreateReplyTemplateFromModal"
    >
      <template #body>
        <div class="w-100 d-flex justify-content-center row">
          <div class="new-reply-template-name-container w-80 mt-1">
            <atom-input
              v-model="newReplyTemplate.replyTemplateName"
              title="Reply Template Name"
              placeholder="Reply Template Name"
              errorMessage="Please enter reply template name"
              :isError="isErrorAtNewReplyTemplateName"
              :isAsterisk="true"
            ></atom-input>
          </div>
          <div class="new-reply-template-message-container w-80 mt-1">
            <atom-text-area
              v-model="newReplyTemplate.replyTemplateMessage"
              title="Reply Template Message"
              placeholder="Reply Template Message"
              errorMessage="Please enter reply template message"
              :isError="isErrorAtNewReplyTemplateMessage"
              :isAsterisk="true"
            ></atom-text-area>
          </div>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal create -->

    <!-- ? Modal Edit Reply Template -->
    <!-- start modal edit -->
    <molecule-modal-dialog
      modalId="modal-edit-reply-template"
      buttonTextLeft="Save Changes"
      buttonColorLeft="primary"
      textTitle="Edit Reply Template"
      :isSlotBody="true"
      :isCloseOnBackDrop="false"
      :isDisableButtonLeft="
        !isTargetReplyTemplateChange || isErrorAtTargetReplyTemplate
      "
      @clickButtonLeft="clickConfirmEditReplyTemplateFromModal"
      @clickButtonRight="clickCancelEditReplyTemplateFromModal"
      @clickIconClose="clickCancelEditReplyTemplateFromModal"
    >
      <template #body>
        <div class="w-100 d-flex justify-content-center row">
          <div class="target-reply-template-name-container w-80 mt-1">
            <atom-input
              v-model="targetReplyTemplate.replyTemplateName"
              title="Reply Template Name"
              placeholder="Reply Template Name"
              errorMessage="Please enter reply template name"
              :isError="isErrorAtTargetReplyTemplateName"
              :isAsterisk="true"
            ></atom-input>
          </div>
          <div class="target-reply-template-message-container w-80 mt-1">
            <atom-text-area
              v-model="targetReplyTemplate.replyTemplateMessage"
              title="Reply Template Message"
              placeholder="Reply Template Message"
              errorMessage="Please enter reply template message"
              :isError="isErrorAtTargetReplyTemplateMessage"
              :isAsterisk="true"
            ></atom-text-area>
          </div>
        </div>
      </template>
    </molecule-modal-dialog>
    <!-- end modal edit -->
  </div>
</template>

<script>
const replacer = (key, value) =>
  value instanceof Object && !(value instanceof Array)
    ? Object.keys(value)
        .sort()
        .reduce((sorted, key) => {
          sorted[key] = value[key]
          return sorted
        }, {})
    : value

import { BCard, BTable } from "bootstrap-vue"

import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"

import mixinsValidator from "@/mixins/mixinsValidator"
import mixinsUser from "@/mixins/mixinsUser"
import { PermissionUser } from "@/constants/permission-user"

export default {
  name: "OrganismTicketReplyTemplateManagement",

  mixins: [mixinsValidator, mixinsUser],

  components: {
    AtomButton,
    AtomInput,
    AtomTextArea,
    BCard,
    BTable,
    MoleculeModalDialog,
  },

  props: {
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  emits: [
    "onSendRequestToCreateReplyTemplate",
    "onSendRequestToUpdateReplyTemplate",
  ],

  data() {
    return {
      modalId: null,
      isValidateNewReplyTemplateTrigger: false,
      isValidateTargetReplyTemplateTrigger: false,
      newReplyTemplate: {
        replyTemplateName: "",
        replyTemplateMessage: "",
      },
      targetReplyTemplate: {
        index: 0,
        replyTemplateId: "",
        replyTemplateName: "",
        replyTemplateMessage: "",
      },
      originTargetReplyTemplate: {
        index: 0,
        replyTemplateId: "",
        replyTemplateName: "",
        replyTemplateMessage: "",
      },
    }
  },

  computed: {
    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.SETTINGS_WRITE)
    },
    isErrorAtNewReplyTemplateName() {
      return this.isValidateNewReplyTemplateTrigger
        ? this.isEmptyString(this.newReplyTemplate.replyTemplateName)
        : false
    },
    isErrorAtNewReplyTemplateMessage() {
      return this.isValidateNewReplyTemplateTrigger
        ? this.isEmptyString(this.newReplyTemplate.replyTemplateMessage)
        : false
    },
    isErrorAtNewReplyTemplate() {
      return (
        this.isErrorAtNewReplyTemplateName ||
        this.isErrorAtNewReplyTemplateMessage
      )
    },
    isTargetReplyTemplateChange() {
      let originData = JSON.stringify(this.originTargetReplyTemplate, replacer)
      let currentData = JSON.stringify(this.targetReplyTemplate, replacer)
      return originData !== currentData
    },
    isErrorAtTargetReplyTemplateName() {
      return this.isValidateTargetReplyTemplateTrigger
        ? this.isEmptyString(this.targetReplyTemplate.replyTemplateName)
        : false
    },
    isErrorAtTargetReplyTemplateMessage() {
      return this.isValidateTargetReplyTemplateTrigger
        ? this.isEmptyString(this.targetReplyTemplate.replyTemplateMessage)
        : false
    },
    isErrorAtTargetReplyTemplate() {
      return (
        this.isErrorAtTargetReplyTemplateName ||
        this.isErrorAtTargetReplyTemplateMessage
      )
    },
  },

  methods: {
    navigateTo(path) {
      this.$router.push(path)
    },

    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = ""
    },

    showCreateNewTicketReplyTemplateModal() {
      this.modalId = "modal-create-new-reply-template"
      this.$bvModal.show(this.modalId)
    },

    clickConfirmCreateReplyTemplateFromModal() {
      this.isValidateNewReplyTemplateTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorAtNewReplyTemplate) {
          const newReplyTemplate = {
            replyTemplateName: this.newReplyTemplate.replyTemplateName,
            replyTemplateMessage: this.newReplyTemplate.replyTemplateMessage,
          }
          this.isValidateNewReplyTemplateTrigger = false
          this.$emit("onSendRequestToCreateReplyTemplate", newReplyTemplate)
          this.closeModal()
          this.setNewReplyTemplateToDefaultValue()
        }
      })
    },

    clickCancelCreateReplyTemplateFromModal() {
      this.isValidateNewReplyTemplateTrigger = false
      this.closeModal()
      this.setNewReplyTemplateToDefaultValue()
    },

    setNewReplyTemplateToDefaultValue() {
      this.newReplyTemplate = {
        replyTemplateName: "",
        replyTemplateMessage: "",
      }
    },

    selectRow(ticketReplyTemplate) {
      if (!this.hasUpdatePermission) return

      this.originTargetReplyTemplate = JSON.parse(
        JSON.stringify(ticketReplyTemplate)
      )
      this.targetReplyTemplate = JSON.parse(JSON.stringify(ticketReplyTemplate))
      this.showEditTicketReplyTemplateModal()
    },

    showEditTicketReplyTemplateModal() {
      this.modalId = "modal-edit-reply-template"
      this.$bvModal.show(this.modalId)
    },

    clickConfirmEditReplyTemplateFromModal() {
      this.isValidateTargetReplyTemplateTrigger = true
      this.$nextTick(() => {
        if (!this.isErrorAtTargetReplyTemplate) {
          const editedReplyTemplate = {
            replyTemplateId: this.targetReplyTemplate.replyTemplateId,
            replyTemplateName: this.targetReplyTemplate.replyTemplateName,
            replyTemplateMessage: this.targetReplyTemplate.replyTemplateMessage,
          }
          this.isValidateTargetReplyTemplateTrigger = false
          this.$emit("onSendRequestToUpdateReplyTemplate", editedReplyTemplate)
          this.closeModal()
          this.setTargetTemplateToDefaultValue()
        }
      })
    },

    clickCancelEditReplyTemplateFromModal() {
      this.isValidateTargetReplyTemplateTrigger = false
      this.closeModal()
      this.setTargetTemplateToDefaultValue()
    },

    setTargetTemplateToDefaultValue() {
      this.originTargetReplyTemplate = {
        index: 0,
        replyTemplateId: "",
        replyTemplateName: "",
        replyTemplateMessage: "",
      }
      this.targetReplyTemplate = {
        index: 0,
        replyTemplateId: "",
        replyTemplateName: "",
        replyTemplateMessage: "",
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.card-padding {
  padding: 1.5rem;
}
</style>
